<!-- Subs -->

<div class="uk-position-relative" *ngIf="menu.active.sub !== '' && menu.active.tab === ''">
    <div class="margin-small-bottom-res margin-large-top-res wrap" *ngIf="menu.active.menu === 'dashboard'">
        <ul class="uk-flex-center" uk-tab>
            <li [class.uk-active]="menu.active.sub === 'activity'">
                <a [routerLink]="['']" (click)="menu.setMenuState('dashboard', 'activity', '')">Activité</a>
            </li>
            <li [class.uk-active]="menu.active.sub === 'map'">
                <a [routerLink]="['']" (click)="menu.setMenuState('dashboard', 'map', '')">Carte</a>
            </li>
            <!-- <li [class.uk-active]="menu.active.sub === 'message'">
                <a (click)="menu.setMenuState('dashboard', 'message', '')">Messagerie</a>
            </li>  -->
            <li [class.uk-active]="menu.active.sub === 'society'"
                *ngIf="session.role.ability !== 'super-admin' && session.role.id !== -1">
                <a [routerLink]="['/user/society/informations', session.role.id]">Infos</a>
            </li>
        </ul>
    </div>
</div>

<div class="uk-position-relative" *ngIf="menu.active.sub === 'alert'">
    <div class="margin-large-bottom-res margin-large-top-res wrap">
        <div class="back-button" [routerLink]="['']">
            <img src="../../../assets/icons/Back.svg" width="32px" height="32px" alt="back">
            <span>Tableau de bord</span>
        </div>
    </div>
</div>